import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import PictureComp from '@/components/picture/PictureComp.vue';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import BasicButton from '@/ui-components/BasicButton.vue';
import TitleDetailLink from '@/components/nav/links/TitleDetailLink.vue';

import { useQuery } from '@/helpers/composables/useApollo';
import { usePersistedTodaysDate } from '@/helpers/composables/usePersistedTodaysDate';
import { ObjectType, Platform } from '@/@types/graphql-types';
import { SnowplowContext, SnowplowOldModuleContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import {
	GetGlobalSmallSpotlightTitlesDocument,
	GetGlobalSmallSpotlightTitlesQuery,
	GetGlobalSmallSpotlightTitlesQueryVariables,
} from '@/pages/graphql/queries/GetGlobalSmallSpotlightTitles.query';
import { AssertByTypename } from '@/helpers/graphql-model-helper';
import { GlobalModuleName } from '@/helpers/composables/useGlobalTitles';
import { ImpressionTrackingEvents } from '@/enums/events';
import { defaultObservableOptions } from '@/mixins/types/impressionTracking';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

type SmallSpotlightTitle = NonNullable<GetGlobalSmallSpotlightTitlesQuery['newTitles']['edges']>[number];


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalSmallSpotlight',
  props: {
    language: null,
    country: null,
    moduleName: null
  },
  setup(__props: any) {

const props = __props as {
	language?: string;
	country?: string;
	moduleName: GlobalModuleName;
};



const { todayDate } = usePersistedTodaysDate();

const queryVariables = computed<GetGlobalSmallSpotlightTitlesQueryVariables>(() => ({
	country: props.country,
	date: todayDate.value.toISOString().split('T')[0],
	first: 2,
	filter: { objectTypes: [ObjectType.Show] },
	language: props.language,
	platform: Platform.Web,
}));

const { result } = useQuery<GetGlobalSmallSpotlightTitlesQuery, GetGlobalSmallSpotlightTitlesQueryVariables>(
	GetGlobalSmallSpotlightTitlesDocument,
	queryVariables
);

const globalNewSpotlightTitles = computed(() => result.value?.newTitles.edges ?? []);

const titlesToShow = computed(
	() =>
		globalNewSpotlightTitles.value.filter(title => title.node.__typename === 'Season') as {
			node: AssertByTypename<SmallSpotlightTitle['node'], 'Season'>;
		}[]
);

const moduleContext = computed(() => new SnowplowOldModuleContext('', -1, props.moduleName, ''));

function getBackdrop(backdrops: { backdropUrl: string }[]) {
	return backdrops[0]?.backdropUrl || '';
}

function getTitle(title: any) {
	return title.node.show;
}

function getPackageShortName(title: any) {
	return getTitle(title).watchNowOffer?.package.shortname;
}

function handleMoreInfoClick(title: any, contexts: SnowplowContext[] = []) {
	const titleContext = TrackingHelper.getTitleContextGraphql(
		title.objectId,
		title.objectType,
		title?.content?.seasonNumber
	);

	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'more_info_clicked',
			label: 'new_shows',
		},
		[...contexts, titleContext, moduleContext.value]
	);
}

const observeVisibilityOptions = computed(() => ({
	...defaultObservableOptions,
	callback: (isVisible: boolean) => {
		if (!isVisible) return;

		TrackingHelper.trackEvent(
			ImpressionTrackingEvents.MODULE,
			{
				action: 'impression',
				nonInteraction: true,
			},
			[moduleContext.value]
		);
	},
}));

return { __sfc: true,props, todayDate, queryVariables, result, globalNewSpotlightTitles, titlesToShow, moduleContext, getBackdrop, getTitle, getPackageShortName, handleMoreInfoClick, observeVisibilityOptions, PictureComp, ProviderIcon, BasicButton, TitleDetailLink, faInfoCircle }
}

})